// extracted by mini-css-extract-plugin
module.exports = {"selectionScreen":"SelectionScreen_selectionScreen__uttwE","selectedOption":"SelectionScreen_selectedOption__OAEZF"};